import { GlobalPositionStrategy, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

export class SnackbarPositionStrategy extends GlobalPositionStrategy {
  /**
   * Sets the top position of the overlay. Clears any previously set vertical position.
   * @param value New top offset.
   */
  top(value: string = ''): this {
    super.top();
    if (value === '0') {
      this['_topOffset'] = '64px';
      this['_height'] = 'auto';
    }
    return this;
  }
}

@Injectable()
export class ExtendedPositionBuilder extends OverlayPositionBuilder {
  /**
   * Creates a global position strategy.
   */
  global(): SnackbarPositionStrategy {
    return new SnackbarPositionStrategy();
  }
}
